var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5002,
    cy: 45.4397,
    r: 45.301,
    fill: "#23A26D",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.693 23.8662C32.8069 23.8662 23.1211 33.552 23.1211 45.4381C23.1211 57.3242 32.8069 67.01 44.693 67.01C56.5791 67.01 66.2649 57.3242 66.2649 45.4381C66.2649 33.552 56.5791 23.8662 44.693 23.8662ZM55.0044 40.4766L42.7731 52.7078C42.4711 53.0098 42.0612 53.1824 41.6298 53.1824C41.1983 53.1824 40.7885 53.0098 40.4865 52.7078L34.3816 46.603C33.756 45.9774 33.756 44.942 34.3816 44.3164C35.0072 43.6908 36.0427 43.6908 36.6682 44.3164L41.6298 49.2779L52.7177 38.19C53.3433 37.5644 54.3788 37.5644 55.0044 38.19C55.6299 38.8155 55.6299 39.8294 55.0044 40.4766Z",
    fill: "#23A26D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.dc97e902b991e79fd05156d6b14e6ef8.svg";
export { ForwardRef as ReactComponent };